import { fetchTemplateFileById, useTemplatesList } from 'api/template';
import { useCategoryRepresentations } from 'hooks/useCategoryRepresentation';

export function useTemplatesPage() {
  const { data: templates, isLoading: isTemplatesCategoriesLoading } = useTemplatesList({
    cacheTime: Infinity,
    staleTime: Infinity,
  });
  const categoryRepresentations = useCategoryRepresentations(templates ?? []);

  const onDownload = (id: number) => {
    fetchTemplateFileById(id);
  };

  return {
    categoryRepresentations,
    isTemplatesCategoriesLoading,
    onDownload,
  };
}
